import { useEffect, useState } from "react";
import { Field } from "./fields.tsx"
import SectionCard from "./sectioncard.tsx"
import { Mail, MapPin, Phone, RefreshCw, Save, User } from "lucide-react";

import { useSelector } from "react-redux";
import { RootState } from "../../../state/store.ts";
import axios from "axios";
import { current } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

export default function CustomerProfile({ currentUser, baseUrl }: { currentUser: any, baseUrl: string }) {
    const client = useSelector((state: RootState) => state.client.client);
    const client_uid = client.uid || "clnt_QI9Jd1m0"; // fallback to default if not available

    const default_configs = client ? JSON.parse(client.default_configs) : {};
    interface Customer {
        pm_card_token?: string;
        name?: string;
        email?: string;
        phone?: string;
        address1?: string;
        address2?: string;
        city?: string;
        postal_code?: string;
        country_code?: string;

        // Allow any extra unknown fields
        [key: string]: any;
    }
    const [customer, setCustomer] = useState<Customer>({});

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        try {
            axios.get(baseUrl + '/getCustomerByUID', {
                params: { token: currentUser.token, client_uid: client_uid }
            }).then((res) => {
                if (res.data.status === "OK") {
                    const data = res.data.data;
                    setCustomer(data);
                    setProfile({
                        name: data.name || "",
                        email: data.email || "",
                        phone: data.phone || "",
                        address1: data.address1 || "",
                        address2: data.address2 || "",
                        city: data.city || "",
                        zip: data.postal_code || "",
                        country: data.country_code || "",
                        photo: data.photo
                    })
                    setLoading(false);
                }
            })
        } catch (err) {
            console.error("Error fetching profile:", err);
        }
    }, [])

    /************** DUMMY DATA **************/
    const vippsProfile = {
        name: "Kari Nordmann",
        email: "kari@example.no",
        phone: "+47 99887766",
        address1: "Storgata 12",
        address2: "",
        city: "Oslo",
        zip: "0184",
        country: "Norge",
    };
    const stripeProfile = {
        name: "Ola Nordmann",
        email: "ola@example.no",
        phone: "+47 91234567",
        address1: "Markveien 3",
        address2: "",
        city: "Bergen",
        zip: "5014",
        country: "Norge",
    };

    // Profil
    const [profile, setProfile] = useState({
        name: "",
        email: "",
        phone: "",
        address1: "",
        address2: "",
        city: "",
        zip: "",
        country: "Norge",
        photo: "",
    });
    const [syncedFrom, setSyncedFrom] = useState<string>("");

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const vipps_auth = urlParams.get('vipps_auth');
    const error = urlParams.get('error');
    const session_id = urlParams.get('session_id');

    const [profilePhotoFile, setProfilePhotoFile] = useState<File | null>(null);

    const handleProfilePhoto = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // Local preview instantly
        const previewURL = URL.createObjectURL(file);
        setProfile((prev) => ({ ...prev, photo: previewURL }));

        // Upload to server
        const formData = new FormData();
        formData.append("token", currentUser.token); // your auth
        formData.append("photo", file);

        try {
            const response = await axios.post(
                baseUrl + "/customerUploadProfilePicture",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            // Server returns final URL → update state with production image
            if (response.data?.photoUrl) {
                setProfile((prev) => ({ ...prev, photo: response.data.photoUrl }));
            }
        } catch (error) {
            console.error("Photo upload failed", error);
        }
    };

    //if param vipps_auth=1 exists, set active tab to profile
    //if param session_id
    useEffect(() => {
        //if code empty do nothing
        if (error) {
            window.history.replaceState({}, document.title, window.location.pathname);
            return;
        }
        setLoading(true);
        if (vipps_auth && code) {
            try {
                let formData = new FormData();
                formData.append("code", code || "");
                formData.append("token", currentUser.token);
                axios.post(baseUrl + '/customerSyncFromVipps', formData).then((res) => {
                    if (res.data.status === "OK") {
                        const data = res.data.data;
                        setProfile({
                            name: data.name || "",
                            email: data.email || "",
                            phone: data.phone || "",
                            address1: data.address1 || "",
                            address2: data.address2 || "",
                            city: data.city || "",
                            zip: data.postal_code || "",
                            country: data.country_code || "",
                        });
                        setSyncedFrom("Vipps");
                        setLoading(false);
                        //remove any url params
                        window.history.replaceState({}, document.title, window.location.pathname);
                    }
                })
            } catch (err) {
                console.error("Error syncing from Stripe:", err);
            }
        } else if (session_id) {
            try {
                let formData = new FormData();
                formData.append('session_id', session_id);
                formData.append('token', currentUser.token);
                axios.post(baseUrl + '/customerSuccessAttachedCard', formData).then((res) => {
                    if (res.data.status === "OK") {
                        setLoading(false);
                        //remove any url params
                        window.history.replaceState({}, document.title, window.location.pathname);
                        Swal.fire({
                            icon: 'success',
                            title: 'Suksess',
                            text: 'Vellykket sikret kort detalj',
                            timer: 2000,
                        })
                    }
                })
            } catch (err) {
                console.error("Error success card attach:", err);
            }
        }
    }, [code, vipps_auth, session_id, currentUser?.token, baseUrl])

    function syncFrom(source: "Vipps" | "Stripe") {

        if (source === "Stripe") {
            setLoading(true);
            let formData = new FormData();
            formData.append("token", currentUser.token);
            if (!customer?.pm_card_token) {
                axios.post(baseUrl + '/customerAttachCard', formData).then((res) => {
                    if (res.data.status === "OK") {
                        window.location.href = res.data.url;
                    } else {
                        setLoading(false);
                        Swal.fire({
                            icon: 'error',
                            title: res.data.status,
                            text: res.data.message,
                            showConfirmButton: true,
                        });
                    }
                })
            } else {
                try {
                    axios.post(baseUrl + '/customerSyncFromStripe', formData).then((res) => {
                        if (res.data.status === "OK") {
                            const data = res.data.data;
                            setProfile({
                                name: data.name || "",
                                email: data.email || "",
                                phone: data.phone || "",
                                address1: data.address1 || "",
                                address2: data.address2 || "",
                                city: data.city || "",
                                zip: data.postal_code || "",
                                country: data.country_code || "",
                            });
                            setSyncedFrom(source);
                            setLoading(false);

                        }
                    })
                } catch (err) {
                    console.error("Error syncing from Stripe:", err);
                }
            }
        } else {
            if (default_configs?.vipps_pay === "yes") {
                let vipps_client_id = default_configs?.vipps_client_id || "";
                let redirect_uri = "";
                let endpoint = "";
                if (baseUrl.includes("localhost")) {
                    redirect_uri = "http://localhost:3000/customer/dashboard?vipps_auth=1";
                } else {
                    redirect_uri = window.location.origin + "/customer/dashboard?vipps_auth=1";
                }
                if (default_configs?.vipps_account_mode === "test") {
                    endpoint = "https://apitest.vipps.no/";
                } else {
                    endpoint = "https://api.vipps.no/";
                }
                window.location.href = `${endpoint}access-management-1.0/access/oauth2/auth?client_id=${vipps_client_id}&response_type=code&scope=openid%20name%20phoneNumber%20address%20birthDate%20email&state=8652682f-ba1d-4719-b1ec-8694ba97bde7&redirect_uri=${redirect_uri}`;
            }
        }
    }

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="flex flex-col items-center">
                    <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                    <p className="mt-3 text-gray-600 animate-pulse">Laster inn profil…</p>
                </div>
            </div>
        );
    }

    return (
        <SectionCard
            title="Profil"
            icon={<User className="h-5 w-5 text-purple-700" />}
            actions={
                <div className="flex items-center gap-2">
                    {default_configs.vipps_pay === "yes" && (
                        <button onClick={() => syncFrom("Vipps")} className="inline-flex items-center gap-2 rounded-full bg-orange-400 border px-3 py-1 text-sm"><RefreshCw className="h-4 w-4" /> Vipps</button>
                    )}
                    <button onClick={() => syncFrom("Stripe")} className="inline-flex items-center gap-2 rounded-full bg-purple-600 text-white border px-3 py-1 text-sm"><RefreshCw className="h-4 w-4" /> Stripe</button>
                </div>
            }
        >
            {syncedFrom && (
                <div className="mb-4 rounded-xl bg-green-50 p-3 text-green-800 text-sm">Profil oppdatert fra {syncedFrom}.</div>
            )}
            <div className="grid gap-4 md:grid-cols-2">
                <Field label="Navn">
                    <input value={profile.name} onChange={(e) => setProfile({ ...profile, name: e.target.value })} className="rounded-xl border px-3 py-2" />
                </Field>
                <Field label="E‑post">
                    <div className="flex items-center gap-2">
                        <Mail className="h-4 w-4 text-purple-700" />
                        <input value={profile.email} onChange={(e) => setProfile({ ...profile, email: e.target.value })} className="flex-1 rounded-xl border px-3 py-2" />
                    </div>
                </Field>
                <Field label="Telefon">
                    <div className="flex items-center gap-2">
                        <Phone className="h-4 w-4 text-purple-700" />
                        <input value={profile.phone} onChange={(e) => setProfile({ ...profile, phone: e.target.value })} className="flex-1 rounded-xl border px-3 py-2" />
                    </div>
                </Field>
                <Field label="Adresse linje 1">
                    <div className="flex items-center gap-2">
                        <MapPin className="h-4 w-4 text-purple-700" />
                        <input value={profile.address1} onChange={(e) => setProfile({ ...profile, address1: e.target.value })} className="flex-1 rounded-xl border px-3 py-2" />
                    </div>
                </Field>
                <Field label="Adresse linje 2 (valgfri)">
                    <input value={profile.address2} onChange={(e) => setProfile({ ...profile, address2: e.target.value })} className="rounded-xl border px-3 py-2" />
                </Field>
                <Field label="Postnummer">
                    <input value={profile.zip} onChange={(e) => setProfile({ ...profile, zip: e.target.value })} className="rounded-xl border px-3 py-2" />
                </Field>
                <Field label="Sted">
                    <input value={profile.city} onChange={(e) => setProfile({ ...profile, city: e.target.value })} className="rounded-xl border px-3 py-2" />
                </Field>
                <Field label="Land">
                    <input value={profile.country} onChange={(e) => setProfile({ ...profile, country: e.target.value })} className="rounded-xl border px-3 py-2" />
                </Field>
                {/* Profile Picture Upload */}
                <Field label="Profilbilde">
                    <div className="flex items-center gap-4">

                        {/* Preview */}
                        <img
                            src={profile.photo || "/default-avatar.png"}
                            alt="Profile"
                            className="w-20 h-20 rounded-full object-cover border"
                        />

                        {/* Upload Button */}
                        <div>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleProfilePhoto}
                                className="hidden"
                                id="profilePhotoInput"
                            />
                            <label
                                htmlFor="profilePhotoInput"
                                className="cursor-pointer bg-purple-600 text-white px-4 py-2 rounded-full shadow-md text-sm hover:bg-purple-700 transition"
                            >
                                Last opp bilde
                            </label>
                        </div>

                    </div>
                </Field>
            </div>
        </SectionCard>
    )

}